import Http from '@/utils/request'
import type { MessageHistoryResponse } from './type'

export function fetchMessageHistory(uid: string, pageNo: number = 1): Promise<MessageHistoryResponse> {
  return Http({
    url: '/user/pipe/history',
    method: 'get',
    params: {
      uid,
      pageNo: Math.max(1, pageNo),
    },
  })
}

export type {
  MessageHistoryItem,
  MessageHistoryPage,
  MessageHistoryResponse,
} from './type'
